import { IonContent, useIonRouter, useIonViewDidEnter } from "@ionic/react";
import GroupChannelUI from "@wearesweet/sendbird-uikit-react/GroupChannel/components/GroupChannelUI";
import { GroupChannelProvider } from "@wearesweet/sendbird-uikit-react/GroupChannel/context";
import React, { useEffect, useState } from "react";
import { debug } from "../../App";
import { useViewport } from "../../utils/useViewport";
import { ChannelSettings } from "./ChannelSettings";
import ChannelHeader from "./components/ChannelHeader";
import { MessageReportRequest, ReportModal } from "./components/ReportModal";

export const Channel = (props: any) => {
  const { isMobile, isDesktop } = useViewport();
  const [report, setReport] = useState<null | MessageReportRequest>(null);
  const [settingsIsOpen, setSettingsIsOpen] = useState<boolean>(props.settingsIsOpen || false);

  // dirty hack because from some routes we don't get props.params.match
  const [channelUrl, setChannelUrl] = useState<string>("");
  const router = useIonRouter();

  useEffect(() => {
    const matches = props.location.pathname.match(/\/channels\/(\w*)\//);

    if (matches && matches[1]) {
      setChannelUrl(matches[1]);
    }
  }, [props.location.pathname]);

  useEffect(() => {
    const receiveReport = (event: any) => {
      debug("Received report", event.detail);
      setReport(event.detail);
    };

    window.addEventListener("sendbird.report", receiveReport);

    return () => {
      window.removeEventListener("sendbird.report", receiveReport);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("chat-channel");

    return () => {
      document.body.classList.remove("chat-channel");
    };
  });

  useIonViewDidEnter(() => {
    debug("Channel.tsx", "useIonViewDidEnter", "props", props);
  });

  return (
    <GroupChannelProvider
      channelUrl={channelUrl}
      onBackClick={() => {
        router.push(isMobile ? "/mchat" : "/chat", isMobile ? "back" : "root");
      }}
      onChatHeaderActionClick={() => {
        debug("onChatHeaderActionClick");

        if (isMobile) {
          router.push(`/mchat/channels/${channelUrl}/settings`, isDesktop ? "none" : "forward");
        } else {
          setSettingsIsOpen(!settingsIsOpen);
        }
      }}
      //highlightedMessage={props.match.params.highlightMessageId}
      onSearchClick={() => {
        router.push(`/chat/channels/${props.channelUrl}/search`);
      }}
      scrollBehavior={"auto"}
    >
      {isMobile ? <ChannelHeader {...props} /> : ""}
      <IonContent fullscreen={true} scrollY={false}>
        <div className={"sendbird-chat-" + (isMobile ? "mobile" : "desktop") + " sendbird-chat--channel"}>
          <GroupChannelUI
            //@ts-ignore
            renderChannelHeader={(props: any) => {
              // No channel header on mobile because it's dealt with in the page itself
              return (
                <>
                  <ReportModal
                    report={report}
                    onDidDismiss={() => {
                      setReport(null);
                    }}
                  />
                  {!isMobile && <ChannelHeader {...props} />}
                </>
              );
            }}
          />

          {settingsIsOpen && (
            <ChannelSettings
              channelUrl={props.match.params.channelUrl}
              onClose={() => {
                setSettingsIsOpen(false);
              }}
            />
          )}
        </div>
      </IonContent>
    </GroupChannelProvider>
  );
};
